export default [
  {
    path: "/exercises",
    name: "exercises",
    component: () => import("@/views/pages/exercises/Exercises.vue"),
    meta: {
      hasPermission:true,
      pageTitle: "تمرینات",
      breadcrumb: [
        {
          text: "تمرینات",
          active: true,
        },
      ],
    },
  },
  {
    path: "/exercises/add",
    name: "add-exercise",
    component: () => import("@/views/pages/exercises/exercise-form/ExerciseForm.vue"),
    meta: {
      hasPermission:true,
      pageTitle: "اضافه کردن تمرین",
      breadcrumb: [
        {
          text: "تمرینات",
          to: "/exercises",
        },
        {
          text: "اضافه کردن تمرین",
          active: true,
        },
      ],
    },
  },
  {
      path: "/exercises/:id/edit",
      name: "edit-exercise",
      component: () => import("@/views/pages/exercises/exercise-form/ExerciseForm.vue"),
      meta: {
        hasPermission:true,
        pageTitle: "ویرایش تمرین",
        breadcrumb: [
          {
            text: "تمرینات",
            to: "/exercises",
          },
          {
            text: "ویرایش کردن تمرین",
            active: true,
          },
        ],
      },
    },
    {
      path: "/exercises/:id",
      name: "show-exercise",
      component: () => import("@/views/pages/exercises/show-exercise/ShowExercise.vue"),
      meta: {
        hasPermission:true,
        pageTitle: " تمرین",
        breadcrumb: [
          {
            text: "تمرینات",
            to: "/exercises",
          },
          {
            text: "تمرین",
            active: true,
          },
        ],
      },
    },
];
